import { render } from "./SubmitPage.vue?vue&type=template&id=a937ae34&scoped=true"
import script from "./SubmitPage.vue?vue&type=script&lang=js"
export * from "./SubmitPage.vue?vue&type=script&lang=js"

import "./SubmitPage.vue?vue&type=style&index=0&id=a937ae34&scoped=true&lang=css"

import exportComponent from "/Users/sphotos/GitHub/pios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a937ae34"]])

export default __exports__